import React, { Component } from 'react'
import Card from 'react-bootstrap/Card'



import "../Pages/WorldCountries.css"
export default class CountrieCard extends Component {
    render() {

        return (
            <div >
                { this.props.countries.filter((data)=>{
                      if ( this.props.searchedCountry == null ) return data 
                      else if (data.country.toLowerCase().includes(this.props.searchedCountry.toLowerCase()))
                      return data
                    }).map((data, index) =>


                    <Card className="CountriesContainer" style={{ width: '25em', marginTop: '8px', height: '100px' }}>
                        <Card.Img variant="top" src={data.countryInfo.flag} />
                        <Card.Body>
                            <Card.Title>{data.country}</Card.Title>
                            <Card.Text>
                                <p>Cases : {parseInt(data.cases).toLocaleString('en-US')} </p>
                                <p>Today Cases : {parseInt(data.todayCases).toLocaleString('en-US')}</p>
                                <p>Active  Cases : {parseInt(data.active).toLocaleString('en-US')}</p>
                                <p>Recovred : {parseInt(data.recovered).toLocaleString('en-US')}</p>
                                <p>Today Recovred : {parseInt(data.todayRecovered).toLocaleString('en-US')}</p>
                                <p>Deaths : {parseInt(data.deaths).toLocaleString('en-US')}</p>
                                <p>Today Deaths : {parseInt(data.todayDeaths).toLocaleString('en-US')}</p>
                                <p>Total Tests : {parseInt(data.tests).toLocaleString('en-US')}</p>

                            </Card.Text>
                        </Card.Body>

                        <Card.Body>

                        </Card.Body>
                    </Card>

                )}

            </div>
        )
    }
}
